<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading1 || pageLoading2 || pageLoading3" class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
@if (navbar.userAccess?.Invoice=='Full'){
<div class="row">
	<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		<div class="card">
			<div class="card-header">
				<h5 class="card-title mb-0">
					{{pagetitle}}
				</h5>
			</div>
			<div class="card-body">
				<div class="row mb-2">
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>To&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.company?.name}}
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>Name&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.f_name}} {{caseDetails?.l_name}}
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>Rank&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.rank_name}}
					</div>
					<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
						<strong>Vessel&nbsp;&nbsp;:&nbsp;&nbsp;</strong>
						{{caseDetails?.vessel}}
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		<div class="card">
			<div class="card-body">
				<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
					<div class="row mb-2">
						<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
							<div class="form-floating">
								<input class="form-control" [ngClass]="{'is-invalid':showError('invoice_number')}"
									id="invoice_number" formControlName="invoice_number" placeholder="">
								<label>Invoice Number</label>
							</div>
							<p *ngIf="showError('invoice_number')" class="text-danger">
								<span *ngIf="f.invoice_number.errors?.required">
									Required
								</span>
								<span *ngIf="f.invoice_number.errors?.incorrect">
									{{customError.invoice_number}}
								</span>
							</p>
						</div>
						<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
							<div class="input-group">
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid':showError('invoice_date')}"
										placeholder="" formControlName="invoice_date" ngbDatepicker id="invoice_date"
										#invoice_date="ngbDatepicker" [minDate]="minDate" [container]="'body'" />
									<label>Bill Date*</label>
								</div>
								<button class="btn btn-outline-secondary" (click)="invoice_date.toggle()" type="button">
									<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
								</button>
							</div>
							<p *ngIf="showError('invoice_date')" class="text-danger">
								<span *ngIf="f.invoice_date.errors?.required">
									Required
								</span>
								<span *ngIf="f.invoice_date.errors?.ngbDate">
									Invalid
								</span>
								<span *ngIf="f.invoice_date.errors?.incorrect">
									{{customError.invoice_date}}
								</span>
							</p>
						</div>
						<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
							<div class="input-group">
								<div class="form-floating">
									<input class="form-control" [ngClass]="{'is-invalid':showError('due_date')}"
										placeholder="" formControlName="due_date" ngbDatepicker id="due_date"
										#due_date="ngbDatepicker" [minDate]="minDate" [container]="'body'" />
									<label>Due Date*</label>
								</div>
								<button class="btn btn-outline-secondary" (click)="due_date.toggle()" type="button">
									<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
								</button>
							</div>
							<p *ngIf="showError('due_date')" class="text-danger">
								<span *ngIf="f.due_date.errors?.required">
									Required
								</span>
								<span *ngIf="f.due_date.errors?.ngbDate">
									Invalid
								</span>
								<span *ngIf="f.due_date.errors?.incorrect">
									{{customError.due_date}}
								</span>
							</p>
						</div>
						<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
							<div class="form-floating">
								<input class="form-control" [ngClass]="{'is-invalid':showError('total_amount')}"
									id="total_amount" formControlName="total_amount" placeholder="">
								<label>Total Amount*</label>
							</div>
							<p *ngIf="showError('total_amount')" class="text-danger">
								<span *ngIf="f.total_amount.errors?.required">
									Required
								</span>
								<span *ngIf="f.total_amount.errors?.pattern">
									Invalid
								</span>
								<span *ngIf="f.total_amount.errors?.incorrect">
									{{customError.total_amount}}
								</span>
							</p>
						</div>
						<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
							<!-- <br />
							<ng-toggle formControlName="bill_flag"
								[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
								[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
								[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
								[labels]="{'unchecked': 'Unbilled','checked': 'Billed'}" class="me-1"
								[width]="90"></ng-toggle>
							<ng-toggle formControlName="paid_flag"
								[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
								[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
								[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
								[labels]="{'unchecked': 'Unpaid','checked': 'Paid'}" class="me-1"
								[width]="90"></ng-toggle>
							<ng-toggle formControlName="is_approved"
								[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
								[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
								[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
								[labels]="{'unchecked': 'Unapproved','checked': 'Approved'}" class="me-1"
								[width]="110"></ng-toggle> -->
							<div class="form-floating">
								<textarea class="form-control" [ngClass]="{'is-invalid':showError('address')}"
									id="address" formControlName="address" placeholder="">
								</textarea>
								<label>Address*</label>
							</div>
							<p *ngIf="showError('address')" class="text-danger">
								<span *ngIf="f.address.errors?.required">
									Required
								</span>
								<span *ngIf="f.address.errors?.incorrect">
									{{customError.address}}
								</span>
							</p>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
							<mat-checkbox *ngIf="!f.invoice_number.value" color="primary"
								formControlName="auto_invoice_no" class="me-1">
								Auto Generate Invoice No.
							</mat-checkbox>
							<mat-checkbox color="primary" formControlName="is_invoice_sent" class="me-1">
								Invoice Sent
							</mat-checkbox>
						</div>
						<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
							<div class="form-floating">
								<input class="form-control" [value]="getTeleConsultTotal()" placeholder=""
									[attr.readonly]="true" [attr.disabled]="true">
								<label>
									Total Tele consult amount
								</label>
							</div>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<table class="table table-bordered">
								<thead>
									<tr>
										<th style="width: 15%;">Date<span class="text-danger">*</span></th>
										<th style="width: 25%;">Category<span class="text-danger">*</span></th>
										<th style="width: 40%;">Doctor/Notes</th>
										<!-- <th [ngStyle]="{'width':isAnyTeleConsult()?'30%':'50%'}">
											Notes
										</th> -->
										<th style="width: 15%;">Cost<span class="text-danger">*</span></th>
										<th style="width: 5%;" class="text-center">
											<button type="button" (click)="addRow()" class="btn btn-xs btn-primary">
												Add
											</button>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr formArrayName="line_items"
										*ngFor="let creds of get_rows.controls; let i = index">
										<ng-container [formGroupName]="i">
											<td>
												<div class="input-group">
													<input class="form-control"
														[ngClass]="{'is-invalid':showError2(i,'date')}"
														placeholder="YYYY-MM-DD" formControlName="date" ngbDatepicker
														id="date{{i}}" #date="ngbDatepicker" [minDate]="minDate"
														[container]="'body'" />
													<button class="btn btn-outline-secondary" (click)="date.toggle()"
														type="button">
														<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
													</button>
												</div>
												<p *ngIf="showError2(i,'date')" class="text-danger">
													<span *ngIf="creds.get('date')?.errors?.required">
														Required
													</span>
													<span *ngIf="creds.get('date')?.errors?.ngbDate">
														Invalid
													</span>
												</p>
											</td>
											<td>
												<select class="form-select"
													[ngClass]="{'is-invalid':showError2(i,'test_id')}" id="test_id{{i}}"
													formControlName="test_id" (change)="categoryChanged(i)">
													<option [value]="null">--Select--</option>
													<option *ngFor="let opt of billCategoryList" [value]="opt.id">
														{{opt.name}}
													</option>
												</select>
												<p *ngIf="showError2(i,'test_id')" class="text-danger">
													<span *ngIf="creds.get('test_id')?.errors?.required">
														Required
													</span>
												</p>
											</td>
											<td>
												@if(isTeleConsult(i)){
												<ng-select [items]="doctorList" bindValue="id" bindLabel="name"
													[clearable]="true" placeholder="Select Doctor*"
													[ngClass]="{'is-invalid':showError2(i,'tele_consult_dr_id')}"
													id="tele_consult_dr_id{{i}}" formControlName="tele_consult_dr_id"
													appearance="outline" (change)="doctorChanged(i)">
												</ng-select>
												<p *ngIf="showError2(i,'tele_consult_dr_id')" class="text-danger">
													<span *ngIf="creds.get('tele_consult_dr_id')?.errors?.required">
														Required
													</span>
												</p>
												}@else {
												<input class="form-control"
													[ngClass]="{'is-invalid':showError2(i,'notes')}"
													formControlName="notes" id="notes{{i}}" />
												<p *ngIf="showError2(i,'notes')" class="text-danger">
													<span *ngIf="creds.get('notes')?.errors?.required">
														Required
													</span>
												</p>
												}
											</td>
											<td>
												<input class="form-control"
													[ngClass]="{'is-invalid':showError2(i,'cost')}"
													formControlName="cost" id="cost{{i}}"
													(ngModelChange)="calculateAmount()" />
												<p *ngIf="showError2(i,'cost')" class="text-danger">
													<span *ngIf="creds.get('cost')?.errors?.required">
														Required
													</span>
													<span *ngIf="creds.get('cost')?.errors?.pattern">
														Invalid
													</span>
												</p>
											</td>
											<td class="text-center">
												<button type="button" (click)="deleteRow(i)"
													class="btn btn-xs btn-danger" matTooltip="Remove">
													@if (
														creds.get('id')?.value &&
														deleteLoader == creds.get('id')?.value
														) {
													<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
													}@else {
													<fa-icon [icon]="['fas', 'times']"></fa-icon>
													}
												</button>
											</td>
										</ng-container>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<button type="submit" class="btn btn-sm btn-success me-1"
								[disabled]="showLoader || !modform.dirty">
								<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
								<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
								Submit
							</button>
							<a type="button" class="btn btn-sm btn-secondary" [routerLink]="['/app/case-invoice',uId]">
								Cancel
							</a>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}